module.exports = __webpack_public_path__ + "img/default-crypto.a8d9800d.svg";